export default class{constructor(){var t,s;this.set=void 0,this.get=void 0,this.get=i=>i===t?s:void 0,this.set=(i,e)=>{t=i,s=e}}}
//# sourceMappingURL=index.mjs.map
